<div class="address-conatiner">
  <div class="address-mobileHeader">
    <app-mobile-header [title]="'label.delivery.address'" [dialogHeader]="true" [manualBackEvent]="true"
      (onManualBackEvent)="onCloseAddress()"></app-mobile-header>

    <app-address-search [addressType]="addressType" (outputSelectedAddress)="selectAddress($event)"
      [searchValue]="currentAddress"></app-address-search>

    <div class="invalid-feeback" *ngIf="outOfService">
      <i class="icon-alert"></i>
      {{ 'desc.selected.address.too.far.to.delivery.try.again' | translate }}
    </div>
  </div>

  <div class="address-list-content" [style.padding-top]="outOfService ? '140px' : '125px' ">
    <div class="recentAddress-content" *ngIf="recentAddress && recentAddress?.fullAddress" (click)="selectRecentAddress(recentAddress)">
        <label>{{'label.recent.address' | translate}}</label>
      <div class="recentAddress">
        <h1>{{recentAddress?.fullAddress}}</h1>
        <app-button [textButton]="true" [buttonName]="'button.save' | translate" (click)="addNewAddressEmit(true)"></app-button>
      </div>
    </div>

    <app-address-list [savedAddress]="savedAddress"
    [isCartPage]="isCartPage"
    (displayAddAddressForm)="addNewAddressEmit(false)" (editSelectedAddress)="editAddressEmit($event)" (outputSelectedAddress)="selectCloseAddress($event)" *ngIf="isUserLogin">
  </app-address-list>
  </div>
</div>
